import { useEffect, useRef, useState } from "react";
import { dateDisplayFormater, getDateSaveFormat } from "../../../Utils";
import { useSelector } from "react-redux";
import Icon from "../../controls/Icons/Icon";
import { Button, Col, Form, Row } from "react-bootstrap";

const PCPNotes = ((pcpInputValue) =>{

const clientId = Number(pcpInputValue.pcpInputValue.id);

const state = useSelector(state => state);

const [cmtsOpen,setcmtsOpen] = useState(pcpInputValue.pcpInputValue.openNotes);
const [translatorOpen,settranslatorOpen] = useState(pcpInputValue.pcpInputValue.openTranslator);
const today = new Date(); 
   
const UserStore = JSON.parse(localStorage.getItem("user"));
const [Notesloading,setNotesloading]=useState(false);
const [lastUpdateDate, setlastUpdateDate] = useState("");
const [inputNotesValue, setinputNotesValue] = useState({
        Id: 0,
        Notes:"",
        fkClientId:"",
        CreatedById:"",
        ModifiedById:"",
        UpdatedDate: null,
        CreatedDate:null,
       
    });
    
const languages = [{code:"en",name:"Engilsh"},
                       {code:"es",name:"Spanish"},
                       {code:"fr",name:"French"},
                       {code:"ta",name:"Tamil"},
                       {code:"hi",name:"Hindi"},
                       {code:"zh",name:"Chinese"},
    ]
const [selectedFromlanguage,setselectedFromlanguage]=useState("en");
const [selectedTolanguage,setselectedTolanguage]=useState("es");
const [TranslatedNotes,setTranslatedNotes]=useState();
const txtNotesRef = useRef(null);
const txtTransNotesRef=useRef(null);
const [lblTransTextCopy,setlblTransTextCopy]=useState("Copy");
 const handleChange = ((e) => {
        const name = e.target.name;
        let value = e.target.value;
        let maxLength = e.target.maxLength;
        if (e.target.type === "checkbox") {
            value = e.target.checked;
        }
        else {
            if (maxLength && maxLength > 0 && value.length > maxLength) {
                return;
            }
     }
     if (Notesloading) setNotesloading(false);
     setinputNotesValue(c => ({ ...c, [name]: value }));
   
    });

 const SaveData = ((e) => {
        e.preventDefault();
        e.stopPropagation();
      let updateSaveDateFormat = getDateSaveFormat(today);
    inputNotesValue.fkClientId =clientId;
    inputNotesValue.CreatedById = UserStore.Id;
    inputNotesValue.ModifiedById = UserStore.Id;
    inputNotesValue.UpdatedDate = updateSaveDateFormat;


         if (!inputNotesValue.Notes) {
            return false;
            }
     setNotesloading(true);
     fetch(state.projectdetail.API + "/Notes/SaveNotes", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
               
               body: JSON.stringify(JSON.parse(JSON.stringify(inputNotesValue))),
            }).then(response => response.json()).then((res) => {
                if (res.Succeeded) {
                   setinputNotesValue(res.Data);
                    setlastUpdateDate(dateDisplayFormater(res.Data.UpdatedDate));
                }
                else {
                    window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }
            }).catch((err) => {
                window.alert(err);
            }).finally(() => {
                setNotesloading(false);
            });
        } );

   
 useEffect(() => {
   
    setcmtsOpen(pcpInputValue.pcpInputValue.openNotes);
    settranslatorOpen(pcpInputValue.pcpInputValue.openTranslator);
       //load notes
             if(clientId>0){
             fetch(state.projectdetail.API + "/Notes/getNotes?fkClientId=" + clientId, {
                             method: "Get"
                   }).then(response => response.json()).then((res) => {
                             if (res.length>0) {
                                 setinputNotesValue(res[0]);
                                 setlastUpdateDate(dateDisplayFormater(res[0]?.UpdatedDate));
                             }
                             else {
                             }
                         }).catch((err) => {
                             console.log(err)
                         }).finally(() => {
                        });
                    }
    
        }, [clientId,pcpInputValue.pcpInputValue.openNotes,pcpInputValue.pcpInputValue.openTranslator]);

        const HandleTranslator =()=>{
    let textarea = txtNotesRef.current;
    let start = textarea.selectionStart;
    let  end = textarea.selectionEnd;
    let inTransText="";
   
    if( end > 0)
    {
      
       inTransText = textarea.value.substring(start, end);
    }
    
    if (inTransText ===""){
      inTransText = inputNotesValue.Notes;
    }
 fetch(state.projectdetail.API + "/Translator/Translate?text="+inTransText+
        "&Fromlanguage="+selectedFromlanguage +"&Tolanguage=" +selectedTolanguage , {
                         method: "Get"
               }).then(response => response.json()).then((res) => {
                  
                      let response = JSON.parse(res.data);
                    
                      if(response !="")
                      {
                        setTranslatedNotes(response[0]?.translations[0]?.text);
                      }
                    }).catch((err) => {
                         console.log(err)
                     }).finally(() => {
                     });
    inTransText = "";
    txtNotesRef.current.selectionStart = 0;
    txtNotesRef.current.selectionEnd = 0;
    txtNotesRef.current.focus();
 }


const handleCpyTranslateText =()=>{
   //copiedtoClipboard
    navigator.clipboard.writeText(txtTransNotesRef.current.value).then(() => {
        setlblTransTextCopy("Copied");
        setTimeout(() =>{ 
        setlblTransTextCopy("Copy");
      }, 3000); // reset after 1.5s
    });
    return false;
}
return(
    <>
    <Form>
                        <Row>
                            <Col md="auto">
                            
                                     <span className="d-inline-block" style={{ color: "white" }}>Last Updated: {lastUpdateDate}</span>
                            </Col>
                        </Row>
                        <Row>
                        <Col md="auto">
                    <Form.Group>
                        {cmtsOpen && !translatorOpen &&
                        <Form.Control required as="textarea" ref={txtNotesRef}  name="Notes" style={{ height: "580px", width:"360px",resize:"none" }}   placeholder="Enter notes here" value={inputNotesValue.Notes} onChange={handleChange} onBlur={(e) => SaveData(e)}  autoComplete="off" />
                        }
                        {!cmtsOpen && translatorOpen &&
                        <Form.Control required as="textarea"  ref={txtNotesRef}  name="Notes" style={{ height: "250px", width:"360px",resize:"none" }}   placeholder="Enter notes here" value={inputNotesValue.Notes} onChange={handleChange} onBlur={(e) => SaveData(e)}  autoComplete="off" />
                        }
                        <Form.Control.Feedback type="invalid">Please provide the notes</Form.Control.Feedback>
                    </Form.Group>
                </Col>
                </Row>
                <Row className='mb-2'>
                    <Col></Col>
                </Row>
                {!cmtsOpen && translatorOpen &&
                 <Row className='mb-2'>
                   {/* <Col> <span className="d-inline-block" style={{ color: "white" }}>From</span> </Col> */}
                    <Col style={{width:'35%'}}>
                   <select value={selectedFromlanguage} onChange={(e) => setselectedFromlanguage(e.target.value)} style={{width:120,height:35}}>
                        <option value="">-- Select --</option>
                        {languages.map((lang) => (
                            
                     <option key={lang.code} value={lang.code}  >
                           
                    {lang.name}
                     </option>
                      ))}
                </select>
                </Col>
                <Col style={{width:'30%'}} >
                    <Button variant='warning' onClick={HandleTranslator}>Translate</Button>
                </Col>
                 <Col style={{width:'35%'}} >
                     
                <select value={selectedTolanguage} onChange={(e) => setselectedTolanguage(e.target.value)} style={{width:120,height:35}}>
                        <option value="">-- Select --</option>
                        {languages.map((lang) => (
                     <option key={lang.code} value={lang.code}>
                    {lang.name}
                     </option>
                      ))}
                </select>
                </Col>
                <Col style={{width:'10%'}} >
                </Col>
                </Row>
                    }
                {!cmtsOpen && translatorOpen &&
                    <Row className='mb-2'>
                    <Col >
                    
                        <div style={{ position: "relative", width: "360px",height: "280px" }}>
                        <Form.Control required as="textarea"  ref={txtTransNotesRef} name="TranslatedNotes" className="d-inline-block" style={{ height: "280px", width:"100%",paddingRight: "80px", resize:"none" }}  value ={TranslatedNotes} placeholder="Translated notes"     autoComplete="off" />
                         <Button variant='primary'  style={{
                                position: "absolute",
                                right: "5px",
                                bottom: "5px",
                                }} onClick={handleCpyTranslateText}>{lblTransTextCopy}</Button>
                        </div>
                    
                    </Col>
                </Row>
                }
                </Form>
    
    
    
    
    
    
    </>





)




})
export default PCPNotes;